export const isLastItem = ({ resource, resourceList }) =>
    resourceList && resourceList[resourceList.length - 1].id !== resource.id
